<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>
    <!--TOPIC DAN PEROIDE BERITA-->
    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDate1 === '' && showDate2 === '') || (showDate1 !== '' && showDate2 !== '' && selectedPeriode !== 'Custom'),
        'd-flex ma-0 pa-0 ml-1': showDate1 !== '' && showDate2 !== '' && selectedPeriode === 'Custom'
      }"
      :style="navbarWithName ? 'margin-left: 10px !important;' : ''"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          label="Topic"
          dense
          outlined
          rounded
          @change="statusFilter = '', parameter_proses_topic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topickeywordsentiment"
          v-model="selectedKeyword"
          class="elevation-0 shadow-0"
          label="Keyword"
          dense
          outlined
          rounded
          @change="parameter_proses_keyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          label="Periode Berita"
          dense
          outlined
          rounded
          @change="parameter_proses_periode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small dark width="120" color="#0471A5">
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row justify="space-around" class="ma-4">
                      <v-date-picker
                        v-model="date1"
                        dense
                        :show-current="false"
                        color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="date2"
                        class="ml-8"
                        :show-current="false"
                        color="#0471A5"
                        header-color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="menu = false, parameter_proses_custom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Button Hit API -->
      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDate1 === '' && showDate2 === '') || (showDate1 !== '' && showDate2 !== '' && selectedPeriode !== 'Custom'),
          'd-flex ma-0 pa-0': showDate1 !== '' && showDate2 !== '' && selectedPeriode === 'Custom'
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          block
          @click="isSearch = true, parameter_proses_periode(), start_loader_data()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
      <!-- End Button Hit API -->

      <!-- Hide filter button -->
      <!-- <v-col
        v-if="(showDate1 == '' && showDate2 == '' || showDate1 != '' && showDate2 != '') && selectedPeriode != 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      > -->
        <!-- Filter logika -->
        <!-- <v-btn
          class="mr-3"
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          outlined
          block
          @click="dialogFilterLogika = true"
        >
          <v-icon>mdi-plus</v-icon>
          Filter
        </v-btn>
      </v-col> -->

      <v-col
        v-if="(showDate1 == '' && showDate2 == '' || showDate1 != '' && showDate2 != '') && selectedPeriode != 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <!-- Reset -->
        <v-btn
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>

      <!-- <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      > -->
        <!-- Filter logika -->
        <!-- <v-btn
          class="mr-3"
          color="#439EDF"
          height="40"
          style="max-width: 100%;"
          dense
          dark
          rounded
          outlined
          block
          @click="dialogFilterLogika = true"
        >
          <v-icon>mdi-plus</v-icon>
          Filter
        </v-btn>
      </v-col> -->

      <v-col
        v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'"
        class="d-flex ma-0 pa-0 mb-2 ml-3"
        cols="12"
        sm="1"
      >
        <!-- Reset -->
        <v-btn
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="400px" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <div>
              <v-card-title>Sentiment Analysis</v-card-title>
              <apexchart
                :options="chartPie"
                :series="seriesdonut"
                class="mt-2"
                type="donut"
                width="370px"
                @dataPointSelection="filterBySentiment"
              ></apexchart>
            </div>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-5 mb-6 rounded-lg' : 'mr-4 mb-6 rounded-lg'" height="320px" flat>
          <v-card-title class="class-title">Tag Cloud News</v-card-title>
          <v-flex lg12>
            <div class="example">
              <v-card flat height="320px">
                <vue-wordcloud
                  class="wordcloudclass"
                  :data="wordsNews"
                  nameKey="name"
                  valueKey="value"
                  :wordPadding="4"
                  :rotate="rotate"
                  spiral="rectangular"
                  :fontSize="F_size"
                  :color="colorWordCloud"
                  font="Roboto"
                  @mouseover="handleMouseOver"
                  @mouseout="handleMouseOut"
                  :wordClick="wordClickHandler"
                />
                <div v-if="tooltipVisible" class="tooltip" :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
                  {{ tooltipContent }}
                </div>
              </v-card>
            </div>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-2 mb-6 rounded-lg' : 'mr-2 mb-6 rounded-lg'" height="320px" flat>
          <v-card-title class="class-title">Tag Cloud Social Media</v-card-title>
          <v-flex lg12>
            <div class="example">
              <v-card flat height="320px">
                <vue-wordcloud
                  class="wordcloudclass"
                  :data="wordsSocialMedia"
                  nameKey="name"
                  valueKey="value"
                  :wordPadding="4"
                  :rotate="rotate"
                  spiral="rectangular"
                  :fontSize="F_size"
                  :color="colorWordCloud"
                  font="Roboto"
                  @mouseover="handleMouseOver"
                  @mouseout="handleMouseOut"
                  :wordClick="wordClickHandler"
                />
                <div v-if="tooltipVisible" class="tooltip" :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
                  {{ tooltipContent }}
                </div>
              </v-card>
            </div>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex lg6 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="400px" flat>
          <v-card-title>Top Person</v-card-title>
          <div class="example">
            <apexchart
              :options="barchart"
              :series="seriesBarPerson"
              type="bar"
              height="300"
              @click="clickChartBarPerson"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg6 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-2 mb-6 rounded-lg pa-4' : 'mr-2 mb-6 rounded-lg pa-4'" height="400px" flat>
          <v-card-title>Top Organization</v-card-title>
          <div class="example">
            <apexchart
              :options="barchartOrganisasi"
              :series="seriesBarOrganisasi"
              type="bar"
              height="300"
              @click="clickChartBarOrganisasi"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg12 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mr-2 mb-6 rounded-lg pa-4' : 'ml-4 mr-2 mb-6 rounded-lg pa-4'" height="550px" flat>
          <v-card-title>Content List</v-card-title>
          <v-tabs v-model="selectedTab" :key="selectedTab" color="#0471A5">
            <v-tab @click="contentListSentiment('Positive')">
              Positive
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ beritaPositivePersen }} % / {{ beritaPositive }} Data
              </v-chip>
            </v-tab>
            <v-tab class="ml-8" @click="contentListSentiment('Netral')">
              Netral
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ beritaNetralPersen }} % / {{ beritaNetral }} Data
              </v-chip>
            </v-tab>
            <v-tab class="ml-8" @click="contentListSentiment('Negative')">
              Negative
              <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                {{ beritaNegativePersen }} % / {{ beritaNegative }} Data
              </v-chip>
            </v-tab>

            <v-tab-item style="background-color: #f5f5f5">
              <v-card class="elevation-0 overflow-card" height="422px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaPositive" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{'rounded-lg custom-card': index === 0, 'mt-2 rounded-lg custom-card': index !== 0}"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-web
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>
                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item style="background-color: #f5f5f5">
              <v-card class="elevation-0 overflow-card" height="422px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaNetral" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{'rounded-lg custom-card': index === 0, 'mt-2 rounded-lg custom-card': index !== 0}"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-web
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>
                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item style="background-color: #f5f5f5">
              <v-card class="elevation-0 overflow-card" height="422px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaNegative" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{'rounded-lg custom-card': index === 0, 'mt-2 rounded-lg custom-card': index !== 0}"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'berita'" class="color-avatar4" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-web
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'Twitter'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'youtube'" class="color-avatar2" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'tik tok'" class="color-avatar6" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'instagram'" class="color-avatar7" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>
                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
        <div v-if="tabsSentiment == 'Positive'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pagePositive"
            :length="pageLengthPositive"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangePositive"
          ></v-pagination>
        </div>
        <div v-if="tabsSentiment == 'Netral'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pageNetral"
            :length="pageLengthNetral"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangeNetral"
          ></v-pagination>
        </div>
        <div v-if="tabsSentiment == 'Negative'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pageNegative"
            :length="pageLengthNegative"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangeNegative"
          ></v-pagination>
        </div>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="#0471A5"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
<!-- 
      <v-dialog v-model="dialogFilterLogika" max-width="500px">
        <v-card style="overflow-x: hidden">
          <v-toolbar height="50px" color="#439EDF" dark>
            Filter logika
          </v-toolbar>
          <v-card-text class="pa-6 overflow-card" style="height: 400px; background-color:#F4F7FA;">
            <v-card class="mb-4" style="background-color:#F4F7FA;" flat>
              <v-row class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsFilterLogika"
                    item-text="logic"
                    item-value="logic"
                    v-model="valueFilterLogika"
                    label="Logic Filter"
                    dense
                    outlined
                    @change="disableLogicFilter"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="valueKataKunci"
                    label="Kata Kunci"
                    dense
                    outlined
                    v-on:input="updateKataKunci"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="listObjFilterLogika.length == 0" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogika()">
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
              <v-row v-for="(item, i) in listObjFilterLogika" :key="i" class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsSelectFilterLogika[i]"
                    item-text="logic"
                    item-value="logic"
                    v-model="listObjFilterLogika[i].operator"
                    dense
                    outlined
                    @change="changeSelectFilterLogika(listObjFilterLogika[i].operator, i)"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="listObjFilterLogika[i].keyword_logic"
                    dense
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="i == listObjFilterLogika.length - 1" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogikaInList(item, i)">
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteFilterLogika(i)">
                      <v-icon color="red">mdi-minus-circle</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Cancel
            </v-btn>
            <v-btn text color="#439EDF" @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <v-dialog v-model="dialogInfo" height="500" width="350">
        <v-card class="pa-5" rounded="lg" color="#439EDF" dark>
          <v-btn class="ml-auto" style="position: absolute; top: 5px; right: 5px; color: white;" icon @click="dialogInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text class="text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
            <h3 class="white--text mb-4">Keyword Search Results</h3>
            <p class="white--text">
              Topic: <strong>{{ selectedTopicTotalCollectedData }}</strong> <br>
              From: <strong>{{ startDateInfo }}</strong> to <strong>{{ endDateInfo }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar color="#eee" style="border: 2px solid #ddd;" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                isClickSentiment = false,
                statusFilter = '',
                isClickWord = '',
                nerPersonSearch = '',
                nerOrganizationSearch = '',
                loadTopic(),
                parameter_proses_periode(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueWordcloud from 'vue-wordcloud';
import Notification from '@/components/Notification';
// import io from 'socket.io-client';
import { decryptionData, generate_filterdate } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
// let ipSocket = process.env.VUE_APP_API;
// import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    VueWordcloud,
    Notification: Notification
    // apexcharts: VueApexCharts,
  },
  data: function() {
    return {
      dialogConfirmReset: false,
      isSearch: false,
      dialogInfo: false,
      startDateInfo: "",
      endDateInfo: "",
      colorWordCloud: ['#0471A5'],
      F_size: [10, 30],
      rotate: { from: 0, to: 0 },
      tooltipVisible: false,
      tooltipContent: '',
      tooltipX: 0,
      tooltipY: 0,
      // socket: io(ipSocket),
      menu: false,
      dialog: false,
      selectedTopic: "",
      selectedTopicTotalCollectedData: "",
      totalCollectedData: "",
      listValueKeyword: [],
      valueMostTotalKeyword: "",
      valueLeastTotalKeyword: "",
      selectedKeyword: "",
      selectedPeriode: "This Week",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeberita: ['Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
      showDate1: "",
      showDate2: "",
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      listSentiment: ["Positive", "Neutral", "Negative"],
      selectedTab: 0,
      tabsSentiment: "Positive",
      pageplay: 100,
      pagePositive: "",
      pageNetral: "",
      pageNegative: "",
      pageLengthPositive: "",
      pageLengthNetral: "",
      pageLengthNegative: "",
      valueKataKunci: "",
      finalObjectFilterLogika: [],
      objFilterLogika: [],
      listObjFilterLogika: [],
      listFilterLogika: [],
      listFilterLogikaLogic: [],
      valueFilterLogika: "Logic Filter",
      itemsFilterLogika: [
        {
          logic: "Logic Filter",
          disabled: false,
        },
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        },
      ],
      itemsSelectFilterLogika: [],
      selectedLogika: "Or",
      // dialogFilterLogika: false,
      isClickSentiment: false,
      statusFilter: "",
      isClickWord: "",
      nerPersonSearch: "",
      nerOrganizationSearch: "",
      alert: false,
      colorAlert: "",
      message: "",
      wordsNews: [],
      wordsSocialMedia: [],
      kontenBeritaAll: [],
      kontenBeritaPositive: [],
      kontenBeritaNetral: [],
      kontenBeritaNegative: [],
      beritaPositivePersen: "",
      beritaPositive: "",
      beritaNetralPersen: "",
      beritaNetral: "",
      beritaNegativePersen: "",
      beritaNegative: "",

      seriesdonut: [],
      chartPie: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        labels: ['Netral', 'Negative', 'Positive'],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
        },
      },

      /*bar chart*/
      isClickBar: "",
      chart_data_sort: [],
      seriesBarPerson: [{
        data: []
      }],
      barchart: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
      chart_data_sortOrganisasi: [],
      seriesBarOrganisasi: [{
        data: []
      }],
      barchartOrganisasi: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  mounted() {
    this.loadTopic();
    // this.getRealTimeData();
  },
  methods: {
    openDialogInfo() {
      this.dialogInfo = true;
      setTimeout(() => {
        this.dialogInfo = false;
      }, 10000);
    },
    wordClickHandler(name) {
      this.isClickWord = name;
      this.loadchart_data();
    },
    handleMouseOver(event, word) {
      this.tooltipContent = word.value;
      this.tooltipX = event.pageX + 10;
      this.tooltipY = event.pageY + 10;
      this.tooltipVisible = true;
    },
    handleMouseOut() {
      this.tooltipVisible = false;
      this.tooltipContent = '';
    },
    getRealTimeData() {
      this.socket.on("listUpdate", fetchedData => {
        // Remove non-printable and other non-valid JSON characters
        var s = fetchedData.replace(/\\n/g, "\\n")
                  .replace(/\\'/g, "\\'")
                  .replace(/\\"/g, '\\"')
                  .replace(/\\&/g, "\\&")
                  .replace(/\\r/g, "\\r")
                  .replace(/\\t/g, "\\t")
                  .replace(/\\b/g, "\\b")
                  .replace(/\\f/g, "\\f");
        var dataUpdate = JSON.parse(s);
        console.log(dataUpdate);
        this.kontenBeritaAll = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        this.kontenBeritaAll = dataUpdate;
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Neutral") {
            this.kontenBeritaNetral.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(dataUpdate[i]);
          }
        }
        this.loadchart_data();
        this.updateSocket = true;
      })
    },
    // update show custom date
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    updateKataKunci() {
      this.objFilterLogika[0].keyword_logic = this.valueKataKunci;
    },
    async loadTopic() {
      this.isSearch = true;
      this.dialog = true;

      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        // this.posts = response.data;
        // const data = response.data;
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;

        for (let i = 0; i < data.length; i++) {
          // sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          // send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          // sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  // this.selectedKeyword = (data[i].KEYWORD[x].KEYWORD);
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
            this.selectedTopicTotalCollectedData = data[i].TOPIC;
          }
        }

        // topickeywordsentiment
        var date_start = this.date1;
        var date_end = this.date2;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generate_filterdate(period);
          date_start = date_v.start_date;
          date_end = date_v.end_date;

        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
            date_start_glob: date_start,
            date_end_glob: date_end,
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.date1 = this.$store.date_start_glob;
          this.date2 = this.$store.date_end_glob;
        }

        this.startDateInfo = date_start;
        this.endDateInfo = date_end;

        if (data.length > 0) {
          this.loader_data();
        }
        if (this.selectedPeriode == "Custom") {
          this.showCustomDate();
        }
      })
      .catch((e) => {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error"); // end up here all the time
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.date1;
      var date_end = this.date2;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        // sincron data topic sentiment
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              // this.selectedKeyword = (this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
    },
    async parameter_proses_keyword() {
      var date_start = this.date1;
      var date_end = this.date2;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      this.parameter_proses_periode();
    },

    async parameter_proses_periode() {
      let date_start = this.date1;
      let date_end = this.date2;
      if (this.selectedPeriode != 'Custom') {
        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generate_filterdate(period);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
      }


      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });

      this.startDateInfo = date_start;
      this.endDateInfo = date_end;
    },

    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";
      var date_start = this.date1;
      var date_end = this.date2;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
    },

    filterBySentiment(event, chartContext, config) {
      const index = config.dataPointIndex;

      if (
        (index == 0 && this.statusFilter == "Neutral") ||
        (index == 1 && this.statusFilter == "Negative") ||
        (index == 2 && this.statusFilter == "Positive")
      ) {
        this.isClickSentiment = false;
        this.statusFilter = "";
        this.$store.commit("addButtonTmp", {
          sentiment_glob: "",
        });
        this.loader_data();
      } else {
        this.isClickSentiment = true;
        if (index == 0) {
          this.statusFilter = "Neutral";
        }
        if (index == 1) {
          this.statusFilter = "Negative";
        }
        if (index == 2) {
          this.statusFilter = "Positive";
        }
      }

      this.$store.commit("addButtonTmp", {
        // sentiment_glob: this.statusFilter,
        // ner_person_glob: this.$store.ner_person_glob,
        // ner_organization_glob: this.$store.ner_organization_glob,
      });

      this.loader_data();
    },

    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
      this.loader_data();
    },

    clickChartBarPerson(event, chartContext, config) {
      this.isClickBar = this.barchart.xaxis.categories[config.dataPointIndex];
      this.nerPersonSearch = this.barchart.xaxis.categories[config.dataPointIndex];
      this.$store.commit('addButtonTmp', {
      });
      this.nerOrganizationSearch = "";
      this.loader_data();
    },
    clickChartBarOrganisasi(event, chartContext, config) {
      this.isClickBar = this.barchartOrganisasi.xaxis.categories[config.dataPointIndex];
      this.nerOrganizationSearch = this.barchartOrganisasi.xaxis.categories[config.dataPointIndex];
      this.nerPersonSearch = "";
      this.$store.commit('addButtonTmp', {
        // sentiment_glob:this.$store.sentiment_glob,
        // ner_person_glob:this.$store.ner_person_glob,
        // ner_organization_glob:this.barchartOrganisasi.xaxis.categories[config.dataPointIndex]
      });

      this.loader_data();
    },
    

    async start_loader_data() {
      this.filterReset()
    },
    async loader_data() {
      let defaultSentimentContent = "Positive";
      if (this.statusFilter != "") {
        defaultSentimentContent = this.statusFilter;
      }
      if (this.tabsSentiment != "Positive") {
        defaultSentimentContent = this.tabsSentiment;
      }
      this.dialog = true;
      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };
      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }



        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        // chat tag cloud data ==============================================
        // proc_date = ['TODAY','FROM_YESTERDAY','THIS_WEEK','PREVIOUS_WEEK','THIS_MONTH', 'PREVIOUS_MONTH'];
        const data_tag_cloud = await axios.post(
          `td-topic-tag-cloud?period=${period}&start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );


        if (data_tag_cloud && data_tag_cloud.data && data_tag_cloud.data.data) {
          const nameCountNews = Array.isArray(data_tag_cloud.data.data.tag_cloud_news) && data_tag_cloud.data.data.tag_cloud_news.length > 0
          ? data_tag_cloud.data.data.tag_cloud_news.reduce((acc, item) => {
              acc[item.keyword] = item.count;
              return acc;
          }, {})
          : {}; // Jika array kosong, hasilkan objek kosong
          if (Object.keys(nameCountNews).length > 0) {
            const resultNews = Object.keys(nameCountNews).map(domain => ({
              name: domain,
              value: nameCountNews[domain]
            }));
            resultNews.sort(function (a, b) { // sort desc value
              return (b.value) - (a.value);
            });
            console.log(resultNews);
            this.wordsNews = [];
            this.wordsNews = resultNews.slice(0, 100);
          }
          const urlObjects = data_tag_cloud.data.data.tag_cloud_news.flatMap(item =>
            item.source.map(src => ({ url: src.url }))
          );
          console.log(urlObjects);


          const nameCountSosmed = Array.isArray(data_tag_cloud.data.data.tag_cloud_socmed) && data_tag_cloud.data.data.tag_cloud_socmed.length > 0
            ? data_tag_cloud.data.data.tag_cloud_socmed.reduce((acc, item) => {
                acc[item.keyword] = item.count;
                return acc;
            }, {})
            : {}; // Jika array kosong, hasilkan objek kosong

          // Proses selanjutnya hanya dilakukan jika nameCountSosmed tidak kosong
          if (Object.keys(nameCountSosmed).length > 0) {
            const resultSocialMedia = Object.keys(nameCountSosmed).map(domain => ({
              name: domain,
              value: nameCountSosmed[domain]
            }));

            resultSocialMedia.sort(function (a, b) { // sort desc value
              return (b.value) - (a.value);
            });

            this.wordsSocialMedia = [];
            this.wordsSocialMedia = resultSocialMedia.slice(0, 100); // Ambil 100 teratas
          }



        }

        // &domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}
        // chat pie data ====================================================
        const data_chart_pie = await axios.post(
          `td-topic-chart-pie?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        if (this.isClickSentiment == false) {
          this.seriesdonut[0] = data_chart_pie.data.data.count_netral;
          this.seriesdonut[1] = data_chart_pie.data.data.count_negative;
          this.seriesdonut[2] = data_chart_pie.data.data.count_positive;
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Neutral") {
            this.seriesdonut[0] = data_chart_pie.data.data.count_netral;
            this.seriesdonut[1] = 0;
            this.seriesdonut[2] = 0;
          }
          if (this.statusFilter == "Negative") {
            this.seriesdonut[0] = 0;
            this.seriesdonut[1] = data_chart_pie.data.data.count_negative;
            this.seriesdonut[2] = 0;
          }
          if (this.statusFilter == "Positive") {
            this.seriesdonut[0] = 0;
            this.seriesdonut[1] = 0;
            this.seriesdonut[2] = data_chart_pie.data.data.count_positive;
          }
        }

        if (this.isClickSentiment == false) {
          var count_all = data_chart_pie.data.data.count_positive + data_chart_pie.data.data.count_netral + data_chart_pie.data.data.count_negative;
          const beritaPositivePersen = data_chart_pie.data.data.count_positive / count_all * 100;
          this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
          this.beritaPositive = data_chart_pie.data.data.count_positive;

          const beritaNetralPersen = data_chart_pie.data.data.count_netral / count_all * 100;
          this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
          this.beritaNetral = data_chart_pie.data.data.count_netral;

          const beritaNegativePersen = data_chart_pie.data.data.count_negative / count_all * 100;
          this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
          this.beritaNegative = data_chart_pie.data.data.count_negative;
          if (isNaN(beritaPositivePersen)) {
            this.beritaPositivePersen = 0;
          }
          if (isNaN(beritaNetralPersen)) {
            this.beritaNetralPersen = 0;
          }
          if (isNaN(beritaNegativePersen)) {
            this.beritaNegativePersen = 0;
          }
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Positive") {
            this.beritaPositivePersen = 100;
            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Netral") {
            this.beritaNetralPersen = 100;
            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Negative") {
            this.beritaNegativePersen = 100;
            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
          }
        }

        // let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
        // if (maxSentiment == this.beritaPositive) {
        //   this.selectedTab = 0;
        //   this.tabsSentiment = "Positive";
        //   this.statusFilter = "Positive";
        //   defaultSentimentContent = this.statusFilter;
        // }
        // if (maxSentiment == this.beritaNetral) {
        //   this.selectedTab = 1;
        //   this.tabsSentiment = "Netral";
        //   this.statusFilter = "Netral";
        //   defaultSentimentContent = this.statusFilter;
        // }
        // if (maxSentiment == this.beritaNegative) {
        //   this.selectedTab = 2;
        //   this.tabsSentiment = "Negative";
        //   this.statusFilter = "Negative";
        //   defaultSentimentContent = this.statusFilter;
        // }

        this.pagePositive = 1;
        this.pageNetral = 1;
        this.pageNegative = 1;
        this.pageLengthPositive = Math.ceil(data_chart_pie.data.data.count_positive / this.pageplay);
        this.pageLengthNetral = Math.ceil(data_chart_pie.data.data.count_netral / this.pageplay);
        this.pageLengthNegative = Math.ceil(data_chart_pie.data.data.count_negative / this.pageplay);

      
        // data ner ====
        const respon_data_ner = await axios.post(
          `td-topic-ner?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data_ner = decryptionData(respon_data_ner.data.token);
        let ner_person = data_ner.ner_person;
        let nerOrganization = data_ner.ner_organization;
        ner_person.forEach((item) => {
          if (item.data !== null) {
            if (item.data.length > 0) {
              item.data.forEach((val, key) => {
                if (key < 6) {
                  this.seriesBarPerson[0].data[key] = "";
                  this.barchart.xaxis.categories[key] = "";
                  this.seriesBarPerson[0].data[key] = val.count;
                  this.barchart.xaxis.categories[key] = val.name;
                }
              });
            }
          }
        });
        nerOrganization.forEach((item) => {
          if (item.data.length > 0) {
            item.data.forEach((val, key) => {
              if (key < 6) {
                this.seriesBarOrganisasi[0].data[key] = "";
                this.barchartOrganisasi.xaxis.categories[key] = "";
                this.seriesBarOrganisasi[0].data[key] = val.count;
                this.barchartOrganisasi.xaxis.categories[key] = val.name;
              }
            });
          }
        });
        // end data ner ====

        const data_content = await axios.post(
          `td-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${defaultSentimentContent}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(data_content.data.token);
        this.kontenBeritaAll = [];
        const content = data.data;

        this.kontenBeritaPositive = [];
        this.kontenBeritaNegative = [];
        this.kontenBeritaNetral = [];

        content.forEach(item => {
          if (item.sentiment == 'Positive') {
            this.kontenBeritaPositive.push(item);
          }
          if (item.sentiment == 'Netral') {
            this.kontenBeritaNetral.push(item);
          }
          if (item.sentiment == 'Negative') {
            this.kontenBeritaNegative.push(item);
          }
        });

        window.dispatchEvent(new Event("resize"));
        this.dialog = false;
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Trending Topic Content Response Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
      }

      if (this.isSearch == true) {
        this.openDialogInfo();
      }

      this.isSearch = false;
    },

    async contentListSentiment(sentiment) {
      this.tabsSentiment = sentiment;
      this.dialog = true;
      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };
      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const authToken = localStorage.getItem('token_app');
      if (!authToken) {
        throw new Error("Auth token not found");
      }
      try {
        const data_content = await axios.post(
          `td-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${sentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(data_content.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNegative = [];
        this.kontenBeritaNetral = [];
        const content = data.data;

        content.forEach(item => {
          if (sentiment == 'Positive') {
            this.kontenBeritaPositive.push(item);
          }
          if (sentiment == 'Netral') {
            this.kontenBeritaNetral.push(item);
          }
          if (sentiment == 'Negative') {
            this.kontenBeritaNegative.push(item);
          }
        });
        this.dialog = false;
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
      }
    },

    async handlePageChangePositive(value) {
      this.dialog = true;

      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `td-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaPositive = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
    async handlePageChangeNetral(value) {
      this.dialog = true;
      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `td-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaNetral = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Neutral" || data.data[i].sentiment == undefined) {
            this.kontenBeritaNetral.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
    async handlePageChangeNegative(value) {
      this.dialog = true;

      const getStoreValue = (key, defaultValue = "") => {
        return this.$store[key] || defaultValue;
      };

      const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
      const startPage = this.pageplay * (value - 1);

      if (this.selectedSource == "berita") {
        this.selectedSource = "mediaonline";
      }
      if (this.selectedSource == "twitter") {
        this.selectedSource = "twitter2";
      }
      if (this.selectedSource == "tik tok") {
        this.selectedSource = "tiktok";
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const data1 = await axios.post(
          `td-topic-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.tabsSentiment}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=${startPage}&rows=${this.pageplay}&sourceCollection=${this.selectedSource}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        const data = decryptionData(data1.data.token);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = data.data;
        this.kontenBeritaNegative = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(data.data[i]);
          }
        }

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    },
  }
}
</script>

<style> /*note css jangan diubah*/
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}
.custom-card {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
}

.custom-card:hover {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
  box-shadow: 3px 5px 7px 0px #E4E4E4 !important;
}
.class-title {
  padding-top: 32px;
  padding-left: 30px;
}

.wordcloudclass {
  min-width: 150px !important;
  max-height: 300px !important;
  margin-top: -8px !important;
  display: flex;
  align-items: flex-start;
}

.wordcloud-container .wordcloudclass text {
  cursor: pointer;
}

div.tooltip {
  background-color: rgb(46, 153, 230) !important;
  color: white !important;
  min-width: 150px !important;
  height: auto !important;
  padding: 8px !important;
  font: 16px Arial !important;
  line-height: 18px !important;
  border: 0px !important;
  border-radius: 2px !important;
  pointer-events: none;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar3 {
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.v-avatar.color-avatar6 {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatar7 {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>
